(() => {
  const money = (cents) => {
    const currency =
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      'USD';

    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency
    }).format(cents / 100);
  };

  const updateBenefitBlocks = async () => {
    const blocks = document.querySelectorAll('[data-customer-benefits]');
    if (!blocks.length) return;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) return;

      const cart = await response.json();

      blocks.forEach((block) => {
        const threshold = Number(block.dataset.freeShippingThreshold || 15000);
        const total = Number(cart.total_price || 0);
        const remaining = Math.max(threshold - total, 0);
        const progress = Math.min((total / threshold) * 100, 100);

        const message = block.querySelector('[data-shipping-message]');
        const progressBar = block.querySelector('[data-shipping-progress]');
        const progressWrap = block.querySelector('[role="progressbar"]');

        if (message) {
          message.textContent =
            total >= threshold
              ? 'You qualify for FREE shipping.'
              : `Spend ${money(remaining)} more for FREE shipping.`;
        }

        if (progressBar) {
          progressBar.style.width = `${progress}%`;
        }

        if (progressWrap) {
          progressWrap.setAttribute('aria-valuenow', String(Math.round(progress)));
        }
      });
    } catch (error) {
      // Keep server-rendered Liquid values if the Ajax refresh fails.
    }
  };

  document.addEventListener('DOMContentLoaded', updateBenefitBlocks);

  // Covers many Shopify themes that update the cart with Ajax.
  document.addEventListener('change', (event) => {
    if (
      event.target.closest('form[action*="/cart"]') ||
      event.target.closest('[data-cart-drawer]') ||
      event.target.closest('.cart')
    ) {
      setTimeout(updateBenefitBlocks, 400);
    }
  });

  // Common custom events used by themes/apps.
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach((eventName) => {
    document.addEventListener(eventName, updateBenefitBlocks);
  });
})();
